import { inject } from '@angular/core';
import { ResolveFn, ActivatedRouteSnapshot } from '@angular/router';
import { forkJoin, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { CreditService } from '../../services/credit/credit.service';
import { CreditDemande, Employeur, EmployeurDocument, EmployeurObservation } from '../../interfaces/credit.interface';

export interface EmployeurDetailResolvedData {
  employeur: Employeur;
  documents: EmployeurDocument[];
  observations: EmployeurObservation[];
  demandes: CreditDemande[];
}

export const employeurDetailCreditResolver: ResolveFn<EmployeurDetailResolvedData> = (route: ActivatedRouteSnapshot) => {
  const id = +route.paramMap.get('id')!;
  const svc = inject(CreditService);
  return forkJoin({
    employeur: svc.getDetailEmployeur(id),
    documents: svc.getDocumentsEmployeur(id),
    observations: svc.getObservationsEmployeur(id),
    demandes: svc.getDemandesEmployeur(id).pipe(catchError(() => of([]))),
  });
};
